import { useMutation } from "@tanstack/react-query";
import instance from "../../service/instance";
import { UPLOADNEWMEMBERSNOTLOGGEDIN } from "../../service/api";

export const useUploadNewEnrollmentBulk = (options = {}) => {
  return useMutation({
    mutationFn: async (formData) => {
      const { data } = await instance.post(
        UPLOADNEWMEMBERSNOTLOGGEDIN,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      return data;
    },
    ...options,
  });
};
